import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { createSmartFielderTheme } from '~/FielderElements/SmartTaskTable/SmartStyles';

const STORAGE_KEY = 'smart-theme-mode';
const COOKIE_OPTIONS = { expires: 365, sameSite: 'lax' };
const getPreferredMode = () => {
	if (typeof window === 'undefined') return 'light';
	const stored = Cookies.get(STORAGE_KEY);
	if (stored === 'dark' || stored === 'light') return stored;
	//const prefersDark = window.matchMedia?.('(prefers-color-scheme: dark)').matches;
	//return prefersDark ? 'dark' : 'light';
};
const SmartThemeContext = createContext({
	mode: 'light',
	setMode: () => {},
	toggleMode: () => {},
});
export const useSmartTheme = () => useContext(SmartThemeContext);
export const SmartThemeProvider = ({ children }) => {
	const [mode, setMode] = useState(getPreferredMode);
	useEffect(() => {
		if (typeof window === 'undefined') return;
		Cookies.set(STORAGE_KEY, mode, COOKIE_OPTIONS);
		document.documentElement.dataset.smartTheme = mode;
	}, [mode]);
	const toggleMode = useCallback(() => {
		setMode((prev) => (prev === 'light' ? 'dark' : 'light'));
	}, []);
	const contextValue = useMemo(
		() => ({
			mode,
			setMode,
			toggleMode,
		}),
		[mode, toggleMode],
	);
	const theme = useMemo(() => createSmartFielderTheme(mode), [mode]);
	return (
		<SmartThemeContext.Provider value={contextValue}>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				{children}
			</ThemeProvider>
		</SmartThemeContext.Provider>
	);
};
SmartThemeProvider.propTypes = {
	children: PropTypes.node.isRequired,
};
